import React, { memo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getTags } from 'services/api/general/tag';
import Autocomplete from '@mui/material/Autocomplete';
import MDInput from 'components/MDInput';

// Loading component to display a loading message
const Loading = () => <div>Yükleniyor</div>;

function Tags({ selectedTags, setSelectedTags, tagGroupID }) {
    // Fetch tags using useQuery hook
    const { data, isLoading, error } = useQuery({
        queryKey: ['tags', tagGroupID],
        queryFn: () => getTags(tagGroupID).then((rp) => rp?.data?.result?.tags),
    });

    // If data is loading, show loading message
    if (isLoading) return <Loading />;

    // If there's an error, show error message
    if (error) return <div>Error: {error.message}</div>;

    // If tags data is available, render the Autocomplete component
    return <TagsAutocomplete selectedTags={selectedTags} setSelectedTags={setSelectedTags} options={data} />;
}

// TagsAutocomplete component renders the Autocomplete component
const TagsAutocomplete = ({ selectedTags, setSelectedTags, options }) => (
    <Autocomplete
        multiple
        value={selectedTags || []}
        options={options || []}
        getOptionLabel={(option) => option.name || ''}
        isOptionEqualToValue={(option, value) => option._id === value._id}
        onChange={(_, value) => setSelectedTags(value)}
        renderInput={(params) => <MDInput {...params} variant="standard" />}
    />
);

export default memo(Tags);
